"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Mobiledoc_1 = require("../../types/Mobiledoc");
var utils_1 = require("../../utils");
var MarkersRenderer_1 = require("../MarkersRenderer");
var ITEM_TAG_NAME = Mobiledoc_1.ListItemTagName.li;
exports.default = (function (_a) {
    var createElement = _a.createElement, getAtomComponent = _a.getAtomComponent, getMarkupComponent = _a.getMarkupComponent;
    return function (_a) {
        var markups = _a.markups, atoms = _a.atoms;
        return function (_a) {
            var tagName = _a[1], items = _a[2];
            return createElement.apply(void 0, __spreadArrays([getMarkupComponent(tagName) ||
                    utils_1.throwError("Unhandled element: the list section tag name `'" + tagName + "'` has no corresponding handler."),
                {}], items.map(function (item) {
                return createElement.apply(void 0, __spreadArrays([getMarkupComponent(ITEM_TAG_NAME) ||
                        utils_1.throwError("Unhandled element: the list item tag name `'" + tagName + "'` has no corresponding handler."),
                    {}], MarkersRenderer_1.default({
                    createElement: createElement,
                    getAtomComponent: getAtomComponent,
                    getMarkupComponent: getMarkupComponent
                })({
                    markups: markups,
                    atoms: atoms
                })(item)));
            })));
        };
    };
});
